var _ellipse, _ellipse2, _path, _path2, _path3, _rect, _path4, _polygon, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _path5, _circle19, _path6, _path7, _path8, _path9, _path10, _circle20, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 966.1545,
    height: 703,
    viewBox: "0 0 966.1545 703",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wine_tasting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.11587,
    cy: 642,
    rx: 463.03862,
    ry: 61,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.61575,
    cy: 402.48077,
    rx: 21.99972,
    ry: 14.9746,
    fill: "#fdbf50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.5385,500.98077s104.49869,181.567,101.74872,207.7726",
    transform: "translate(-116.92275 -98.5)",
    fill: "#fdbf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.28764,513.50582V619.71933c-21.88942-30.33024-65.54944-61.56109-147.36489-86.91331L264.28764,735.22235V736.76s.27836-.15009.7966-.44335l.251.34471s.21043-.28112.58651-.82464C283.09093,725.89141,427.08587,636.219,264.28764,513.50582Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M808.40613,313.61556a74.14625,74.14625,0,0,0-21.88444-15.11979V142.40114A6.90113,6.90113,0,0,0,779.62056,135.5H740.97839a6.90113,6.90113,0,0,0-6.90114,6.90114V295.50152a70.05379,70.05379,0,0,0-48,66.46962v334.8444A30.68446,30.68446,0,0,0,716.76171,727.5H799.535a30.54221,30.54221,0,0,0,30.54221-30.54221v-331.04A73.73486,73.73486,0,0,0,808.40613,313.61556Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 569.1545,
    y: 312.55556,
    width: 144,
    height: 190.22222,
    fill: "#fdbf50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M789.6328,146.16667h-3.11111v-3.76553A6.90113,6.90113,0,0,0,779.62056,135.5H740.97839a6.90113,6.90113,0,0,0-6.90114,6.90114v3.76553h-3.11111v16h3.11111v81.77777h52.44444V162.16667h3.11111Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#fdbf50"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "831.654 524.5 941.654 472.5 953.654 458.5 958.654 464.5 945.654 476.5 845.654 540.5 831.654 524.5",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 887.6545,
    cy: 588.5,
    r: 33,
    fill: "#fdbf50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.6545,
    cy: 588.5,
    r: 33,
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.6545,
    cy: 610.5,
    r: 33,
    fill: "#fdbf50"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.6545,
    cy: 610.5,
    r: 33,
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 731.6545,
    cy: 585.5,
    r: 33,
    fill: "#fdbf50"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.1545,
    cy: 564,
    r: 33,
    fill: "#fdbf50"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 737.1545,
    cy: 535,
    r: 27,
    fill: "#fdbf50"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.1545,
    cy: 585,
    r: 27,
    fill: "#fdbf50"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 759.1545,
    cy: 585,
    r: 27,
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.1545,
    cy: 524,
    r: 24,
    fill: "#fdbf50"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 778.1545,
    cy: 524,
    r: 24,
    opacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.1545,
    cy: 624,
    r: 24,
    fill: "#fdbf50"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.1545,
    cy: 629,
    r: 24,
    fill: "#fdbf50"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.1545,
    cy: 607,
    r: 24,
    fill: "#fdbf50"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 680.1545,
    cy: 607,
    r: 24,
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.1545,
    cy: 588,
    r: 24,
    fill: "#fdbf50"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.1545,
    cy: 552,
    r: 24,
    fill: "#fdbf50"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.1545,
    cy: 552,
    r: 24,
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M866.57725,679a33.14564,33.14564,0,0,0-6.38672.62335,27.00787,27.00787,0,0,0-40.16919-16.17895,24.001,24.001,0,1,0-12.37109,28.6029,26.874,26.874,0,0,0,4.9375,10.7937,27.00008,27.00008,0,0,0,36.82275,37.34626A33.0014,33.0014,0,1,0,866.57725,679Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#fdbf50"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.6545,
    cy: 543.5,
    r: 24,
    fill: "#fdbf50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.57725,609a32.84505,32.84505,0,0,0-18.37549,5.58765A32.97893,32.97893,0,0,0,990.57725,598c-.8418,0-1.67334.04193-2.49951.10388a33.0019,33.0019,0,1,0-55.51123-33.41162A32.9988,32.9988,0,0,0,870.07725,579.5c0,.92664.04785,1.84167.1228,2.749a26.999,26.999,0,1,0,1.20166,53.31269,32.99832,32.99832,0,1,0,47.49707,45.59429,33.02677,33.02677,0,0,0,26.06763,20.51655,33.0008,33.0008,0,1,0,35.22168-20.345,32.93924,32.93924,0,0,0,1.811-18.46038,33.0191,33.0191,0,0,0,26.95362-4.45478A32.99826,32.99826,0,1,0,1037.57725,609Zm-151.7478,18.92371a26.90287,26.90287,0,0,0,7.66015-16.84333A32.98726,32.98726,0,0,0,903.07725,612.5c.46094,0,.918-.016,1.37451-.03479a32.92764,32.92764,0,0,0,.36914,16.50238,33.04676,33.04676,0,0,0-18.99145-1.04388Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#fdbf50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M615.779,432.88243,608.4279,606.5523l-4.59444,78.1055s10.10777,16.54-4.59444,18.37776-42.26886-2.75666-38.5933-11.94555,6.43222-9.18888,6.43222-9.18888l3.67555-88.21326L543.18684,485.25906l-34.91775,116.6988L500.918,685.57669s10.10778,12.86443,0,15.62109-36.75552,2.75667-35.83663-5.51332,4.59444-8.27,4.59444-8.27L465.08135,444.828l13.78332-21.13443Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M595.56347,697.52223l3.67555,22.97221s21.13443,44.10663-8.27,44.10663-21.13443-17.45888-21.13443-17.45888l2.75666-49.62Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M470.59467,697.52223l-3.67555,22.97221s-21.13443,44.10663,8.27,44.10663,21.13442-17.45888,21.13442-17.45888l-2.75666-49.62Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M564.32127,172.83707s9.18888,33.08,11.02666,33.08-17.45888,25.72887-17.45888,25.72887L529.40352,247.267l-10.10777-42.26886s9.18888-22.97221,7.3511-34.91775Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#a0616a"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.69631,
    cy: 53.20264,
    r: 33.99886,
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M545.02462,222.457l27.165-23.59114,16.02278,7.97,34.91776,22.05332s-9.18889,198.47985-4.59445,205.831c0,0-10.10777,22.9722-69.8355,9.18888s-75.34883-15.6211-75.34883-15.6211l12.86443-121.29324L470.59467,230.727l52.47149-36.692,16.44513,28.422Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M646.10232,299.64364s13.78332,43.18775,3.67555,47.78219-18.37776,2.75666-18.37776,2.75666L615.779,312.50808Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M454.97358,292.29254l-8.27,38.5933v78.1055s11.94555,49.62,21.13443,36.75553,8.99911-16.93817,8.99911-16.93817l-11.75577-17.97959,5.51332-73.51105,14.64952-35.06692Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M517.458,117.70378S528.48463,93.81269,549.61906,99.326s33.08,13.78332,33.99886,22.05331-.45944,20.675-.45944,20.675-2.29722-16.99943-16.99943-13.32388-37.67442.91889-37.67442.91889l-3.67555,33.08s-4.135-5.97277-8.72944-2.29722S502.75576,125.05489,517.458,117.70378Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M615.779,230.727l7.35111-1.83778s13.78332,17.45888,18.37776,37.67442,11.02666,40.43108,7.3511,40.43108-36.75552,12.86443-36.75552,12.86443Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M491.7291,228.88925,470.59467,230.727s-23.89109,65.24106-21.13442,67.07884,35.83664,12.86443,40.43108,10.10777S491.7291,228.88925,491.7291,228.88925Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M603.59717,306.04064c-8.8363,5.82417-16.13152,10.19228-21.71052,13.33952h-.005a127.04957,127.04957,0,0,0-24.40742.68549c-5.71908-3.19229-13.43462-7.77054-22.92638-14.025-.09006-.06-.18012-.12008-.27018-.18513v-.005c-8.70624-5.98929-8.92139-18.67334-6.08938-31.6426,7.20516-.80059,18.69338-.45033,34.1294,5.06362,18.27807,6.52965,37.41174,2.837,48.49965-.5204C612.63864,290.1943,611.52783,300.8119,603.59717,306.04064Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#fdbf50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M569.0725,423.62465c-16.73681,0-34.52466-2.54283-34.52466-7.25518,0-4.47634,15.72608-6.86281,30.5218-7.20925V332.55959c0-1.8221-.87855-4.15727-2.61148-6.941a42.06131,42.06131,0,0,0-2.59634-3.67108q-1.23867-.67137-2.631-1.44439c-7.13669-3.9838-14.86071-8.70886-22.9583-14.0447-.09748-.065-.19227-.12851-.28755-.19692l-.20767-.1505c-7.50585-5.33877-9.55077-16.10623-6.07783-32.00993,4.12037-18.89973,14.8077-38.65286,14.91495-38.85026l.21256-.38993.41264.16467c.19888.0794,20.25618,7.84764,51.73008-.02077l.37551-.09382.18519.33985c.01588.02882,1.60344,2.94839,3.75146,7.53248,4.36274,9.29985,9.99152,23.07532,12.02984,35.88916,2.18662,13.74127-.31615,23.08974-7.43915,27.786h0c-7.64,5.03534-14.95429,9.52976-21.74015,13.35769l-.11849.0645q-1.43034.81136-2.7097,1.51035c-.32225.44954-.6362.92254-.93377,1.40775-.39775.64743-.77961,1.33347-1.13558,2.04a30.6506,30.6506,0,0,0-3.19369,13.558l-.45222,70.77957c14.54848.38113,30.00825,2.77689,30.00825,7.19313C603.59717,421.08182,585.80932,423.62465,569.0725,423.62465ZM534.778,305.59257l.0474.03176c8.07486,5.32069,15.77787,10.03305,22.89258,14.00463q1.438.80039,2.71141,1.48739l.09088.04936.064.08111a43.311,43.311,0,0,1,2.72338,3.84259c1.83334,2.945,2.76272,5.458,2.76272,7.47018v77.58033l-.4901.01026c-18.54987.3782-30.03171,3.523-30.03171,6.21929,0,2.95817,13.7679,6.25447,33.524,6.25447s33.524-3.2963,33.524-6.25447c0-2.65619-11.28736-5.78343-29.52256-6.20463l-.492-.01173.45858-71.76269a31.6501,31.6501,0,0,1,3.30094-14.00171c.36818-.73148.764-1.44292,1.17613-2.11332.33105-.53945.68164-1.06571,1.042-1.56264l.06621-.09138.09894-.05424q1.37025-.74833,2.91-1.62176l.12045-.06548c6.73357-3.803,13.98875-8.26225,21.56668-13.257,6.76533-4.46022,9.121-13.475,7.00134-26.79307-2.01975-12.69852-7.61188-26.38017-11.9475-35.62164-1.71461-3.65935-3.06787-6.24763-3.54159-7.1384-29.08109,7.17651-48.48386,1.11212-51.54367.03958-1.49618,2.82575-10.83782,20.888-14.61322,38.205-3.41089,15.62-1.4312,26.0914,5.88408,31.1238Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#f2f2f2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 434.13688,
    cy: 168.51276,
    r: 2.50179,
    fill: "#fdbf50"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.13188,
    cy: 191.5292,
    r: 2.50179,
    fill: "#fff"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.14117,
    cy: 174.51705,
    r: 1.50107,
    fill: "#fdbf50"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 446.14546,
    cy: 203.03742,
    r: 1.50107,
    fill: "#fff"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 435.63796,
    cy: 204.5385,
    r: 1.50107,
    fill: "#fff"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.15976,
    cy: 154.50275,
    r: 1.50107,
    fill: "#fdbf50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M641.50788,320.77807s11.02666,20.21554,8.27,26.64776S624.049,357.5336,621.29234,357.5336s-35.83664-7.35111-35.83664-7.35111-50.53885-23.89109-35.83664-35.83664,42.26886,16.54,42.26886,16.54h22.05331l11.94555-8.27Z",
    transform: "translate(-116.92275 -98.5)",
    fill: "#a0616a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore3);
export default __webpack_public_path__ + "static/media/explore3.04224872a54ec30b36f38b2b319d14f6.svg";
export { ForwardRef as ReactComponent };